import { Suspense } from "react";
import { BrowserRouter as Router, useRoutes } from "react-router-dom";
import Loader from "../components/Loader";
import routes from "./routes";
import ProtectedRoute from "./ProtectedRoute";
import ResponsiveComponent from "../components/common/ResponsiveComponent";
import SessionManager from "../components/sessionManager/SessionManager";

const generateRoutes = (routeList) => {
  return routeList.map(
    ({
      type,
      component: Component,
      mobileComponent: MobileComponent,
      ib,
      children,
      ...rest
    }) => {
      const element = MobileComponent ? (
        <ProtectedRoute type={type} ib={ib} {...rest}>
          <ResponsiveComponent
            mobileComponent={MobileComponent}
            desktopComponent={Component}
          />
        </ProtectedRoute>
      ) : (
        <ProtectedRoute type={type} ib={ib} {...rest}>
          <Component />
        </ProtectedRoute>
      );

      return {
        element,
        children: children?.length ? generateRoutes(children) : null,
        ...rest,
      };
    }
  );
};

const RoutesWrapper = () => {
  return useRoutes(generateRoutes(routes));
};

const AppRoutes = () => {
  return (
    <Router>
      <Suspense fallback={<Loader />}>
        <RoutesWrapper />
      </Suspense>

      <SessionManager />
    </Router>
  );
};

export default AppRoutes;
